<template>
    <div class="relative bg-white shadow-md rounded-xl p-4 m-4">
        <MonkeyLoader v-if="isLoading" />

        <h2 class="text-xl font-semibold mb-6 text-gray-800 border-b pb-2">Entry Template Document GR</h2>
        <form @submit.prevent="saveTemplate">
            <div class="grid grid-cols-1 gap-4">
                <div class="form-section">
                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="categoryCompany">Category
                            Company</label>
                        <div class="flex items-center space-x-2">
                            <select id="categoryCompany" v-model="form.categoryCompanyId"
                                @blur="validateField('categoryCompanyId')" ref="categoryCompanyIdSelect"
                                class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                                <option disabled value="">-- Pilih Kategori --</option>
                                <option v-for="cat in options.categories" :key="cat.id" :value="cat.id">{{ cat.name }}
                                </option>
                            </select>
                            <button @click.prevent="openModal('category')" type="button" class="button-add">
                                <PlusIcon class="h-5 w-5" />
                            </button>
                        </div>
                        <p v-if="!valid.categoryCompanyId" class="text-red-500 text-xs italic mt-1">{{
                            validationMessages.categoryCompanyId }}</p>
                    </div>


                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="customerName">Customer
                            Name</label>
                        <select id="customerName" v-model="form.customerId" @blur="validateField('customerId')"
                            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                            <option disabled value="">-- Pilih Customer --</option>
                            <option v-for="cust in options.customers" :key="cust.id" :value="cust.id">{{ cust.name }}
                            </option>
                        </select>
                        <p v-if="!valid.customerId" class="text-red-500 text-xs italic mt-1">{{
                            validationMessages.customerId }}</p>
                    </div>

                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="typePo">Type PO</label>
                        <div class="flex items-center space-x-2">
                            <select id="typePo" v-model="form.typePoId" @blur="validateField('typePoId')"
                                class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                                <option disabled value="">-- Pilih Tipe PO --</option>
                                <option v-for="type in options.poTypes" :key="type.id" :value="type.id">{{ type.name }}
                                </option>
                            </select>
                            <button @click.prevent="openModal('poType')" type="button" class="button-add">
                                <PlusIcon class="h-5 w-5" />
                            </button>
                        </div>
                        <p v-if="!valid.typePoId" class="text-red-500 text-xs italic mt-1">{{
                            validationMessages.typePoId }}</p>
                    </div>

                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="templateName">Template</label>
                        <div class="flex items-center space-x-2">
                            <select id="templateName" v-model="form.templateId" @blur="validateField('templateId')"
                                class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                                <option disabled value="">-- Pilih Template --</option>
                                <option v-for="temp in options.templates" :key="temp.id" :value="temp.id">{{ temp.name
                                    }}</option>
                            </select>
                            <button @click.prevent="openModal('template')" type="button" class="button-add">
                                <PlusIcon class="h-5 w-5" />
                            </button>
                        </div>
                        <p v-if="!valid.templateId" class="text-red-500 text-xs italic mt-1">{{
                            validationMessages.templateId }}</p>
                    </div>

                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2">Document Checklist</label>
                        <div class="bg-gray-50 p-4 rounded-lg border max-h-80 overflow-y-auto">
                            <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
                                <div v-for="(checked, name) in form.checklist" :key="name">
                                    <label class="flex items-center space-x-3 cursor-pointer">
                                        <input type="checkbox" v-model="form.checklist[name]"
                                            class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
                                        <span class="text-gray-700 text-sm">{{ name }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p v-if="!valid.checklist" class="text-red-500 text-xs italic mt-1">{{
                            validationMessages.checklist }}</p>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-6 pt-4 border-t">
                <button type="submit" :disabled="!isFormValid || isLoading"
                    class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mr-4 transition-all transform hover:scale-105">
                    Save
                </button>
                <button type="button" @click="cancel"
                    class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-transform transform hover:scale-105">
                    Cancel
                </button>
            </div>
        </form>

        <AddModal :show="modal.visible" :title="modal.title" :label="modal.label" @close="closeModal"
            @save="handleSaveFromModal" />
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { PlusIcon } from '@heroicons/vue/24/solid';
import AddModal from './AddModal.vue';
import MonkeyLoader from '../Layout/MonkeyLoader.vue'; // Diperbarui path import

// --- KONFIGURASI INTERCEPTOR UNTUK MENGATUR TOKEN AUTHORIZATION ---
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// --- KONFIGURASI ENDPOINTS API ---
const API_BASE_URL = window.location.origin;
const API_ENDPOINTS = {
    categories: `${API_BASE_URL}/api/companycategory`,
    poTypes: `${API_BASE_URL}/api/potype`,
    templates: `${API_BASE_URL}/api/potemplate`,
    customers: 'https://crm-local.iotech.my.id/po/subcon?bpo=true',
    saveDocument: `${API_BASE_URL}/api/documentfiles`
};

// --- FUNGSI HELPER UNTUK INISIALISASI FORM ---
const getInitialFormData = () => ({
    categoryCompanyId: '',
    customerId: '',
    typePoId: '',
    templateId: '',
    checklist: {
        'PO': false, 'DN': false, 'MRA': false, 'BA': false, 'MOS': false, 'BALAP': false, 'ATP': false,
        'Tes Comm (L1 S/d L3)': false, 'Tes Comm (L1 S/d L5)': false, 'BAUT': false, 'BABT': false,
        'BAST': false, 'ESAR': false, 'GR Number': false, 'ABD(AS Build Drawing)': false,
        'Factory QC certificate/pass': false, 'Warranty Certificate': false,
    }
});

export default {
    name: 'DocumentGrTemplate',
    components: { PlusIcon, AddModal, MonkeyLoader }, // Mendaftarkan komponen di sini
    data() {
        return {
            form: getInitialFormData(),
            options: {
                categories: [],
                customers: [],
                poTypes: [],
                templates: [],
            },
            valid: { categoryCompanyId: true, customerId: true, typePoId: true, templateId: true, checklist: true },
            validationMessages: { categoryCompanyId: '', customerId: '', typePoId: '', templateId: '', checklist: '' },
            isFormValid: false,
            modal: { visible: false, title: '', label: '', type: '', existingItems: [], nameKey: 'name' },
            isLoading: false, // Menambahkan state isLoading
        };
    },
    methods: {
        async fetchData(url, targetState, mapper = null) {
            this.isLoading = true; // Mengaktifkan loader
            try {
                const response = await axios.get(url);
                let data = response.data;
                if (mapper) {
                    data = data.map(mapper);
                }
                this.options[targetState] = Array.isArray(data) ? data : [];
            } catch (error) {
                console.error(`Error fetching ${targetState}:`, error);
                this.options[targetState] = [];
                Swal.fire('Error', `Gagal memuat data untuk ${targetState}.`, 'error');
            } finally {
                this.isLoading = false; // Menonaktifkan loader
            }
        },

        async loadCustomers() {
            this.isLoading = true; // Mengaktifkan loader
            try {
                const response = await axios.get(API_ENDPOINTS.customers);
                const rawData = response.data;

                const customerMap = new Map();
                if (Array.isArray(rawData)) {
                    rawData.forEach(item => {
                        if (item.account && item.account.id && item.account.name) {
                            customerMap.set(item.account.id, {
                                id: item.account.id,
                                name: item.account.name
                            });
                        }
                    });
                }

                const customerArray = Array.from(customerMap.values());
                customerArray.sort((a, b) => a.name.localeCompare(b.name));

                this.options.customers = customerArray;
            } catch (error) {
                console.error('Error fetching customers:', error);
                this.options.customers = [];
                Swal.fire('Error', 'Gagal memuat data customer.', 'error');
            } finally {
                this.isLoading = false; // Menonaktifkan loader
            }
        },

        async loadDropdownData() {
            this.isLoading = true; // Mengaktifkan loader
            try {
                await Promise.all([
                    this.loadCustomers(),
                    this.fetchData(API_ENDPOINTS.categories, 'categories', item => ({ id: item.id, name: item.category })),
                    this.fetchData(API_ENDPOINTS.poTypes, 'poTypes', item => ({ id: item.id, name: item.typename })),
                    this.fetchData(API_ENDPOINTS.templates, 'templates', item => ({ id: item.id, name: item.templatename }))
                ]);
            } catch (error) {
                // Error sudah ditangani di dalam masing-masing metode fetchData, jadi ini bisa diabaikan atau untuk logging tambahan
            } finally {
                this.isLoading = false; // Menonaktifkan loader setelah semua promise selesai
            }
        },

        async saveTemplate() {
            Object.keys(this.valid).forEach(field => this.validateField(field));
            this.updateFormValidity();
            if (!this.isFormValid) {
                Swal.fire('Data Tidak Lengkap', 'Harap isi semua field yang wajib diisi dengan benar.', 'warning');
                return;
            }
            this.isLoading = true; // Mengaktifkan loader

            try {
                const selectedCustomer = this.options.customers.find(c => c.id === this.form.customerId);
                const customerName = selectedCustomer ? selectedCustomer.name : '';

                const details = Object.entries(this.form.checklist)
                    .filter(([, isChecked]) => isChecked)
                    .map(([name]) => ({ docname: name }));

                const payload = {
                    categoryid: this.form.categoryCompanyId,
                    potypeid: this.form.typePoId,
                    potemplateid: this.form.templateId,
                    custid: this.form.customerId,
                    custname: customerName,
                    documentdetails: details
                };

                await axios.post(API_ENDPOINTS.saveDocument, payload);
                Swal.fire('Berhasil!', 'Data dokumen berhasil disimpan.', 'success');
                this.resetForm();
            } catch (error) {
                console.error('Gagal menyimpan dokumen:', error);
                Swal.fire('Gagal', 'Terjadi kesalahan saat menyimpan data ke server.', 'error');
            } finally {
                this.isLoading = false; // Menonaktifkan loader
            }
        },

        async handleSaveFromModal(newValue) {
            this.isLoading = true; // Mengaktifkan loader
            let endpoint = '';
            let payload = {};

            switch (this.modal.type) {
                case 'category':
                    endpoint = API_ENDPOINTS.categories;
                    payload = { category: newValue };
                    break;
                case 'poType':
                    endpoint = API_ENDPOINTS.poTypes;
                    payload = { typename: newValue };
                    break;
                case 'template':
                    endpoint = API_ENDPOINTS.templates;
                    payload = { templatename: newValue };
                    break;
            }

            try {
                const response = await axios.post(endpoint, payload);
                const newItem = response.data;
                await this.loadDropdownData();
                if (this.modal.type === 'category') this.form.categoryCompanyId = newItem.id;
                if (this.modal.type === 'poType') this.form.typePoId = newItem.id;
                if (this.modal.type === 'template') this.form.templateId = newItem.id;
            } catch (error) {
                console.error(`Gagal menyimpan ${this.modal.type}:`, error);
                Swal.fire('Gagal', `Gagal menyimpan ${this.modal.label} baru.`, 'error');
            } finally {
                this.closeModal();
                this.isLoading = false; // Menonaktifkan loader
            }
        },

        resetForm() {
            this.form = getInitialFormData();
            Object.keys(this.valid).forEach(field => {
                this.valid[field] = true;
                this.validationMessages[field] = '';
            });
            this.updateFormValidity();
        },

        validateField(fieldName) {
            this.valid[fieldName] = true;
            this.validationMessages[fieldName] = '';
            let isValid = true;
            switch (fieldName) {
                case 'categoryCompanyId':
                case 'customerId':
                case 'typePoId':
                case 'templateId':
                    if (!this.form[fieldName]) {
                        this.validationMessages[fieldName] = 'This field is required.';
                        isValid = false;
                    }
                    break;
                case 'checklist': {
                    const isAnyChecked = Object.values(this.form.checklist).some(val => val === true);
                    if (!isAnyChecked) {
                        this.validationMessages.checklist = 'At least one document must be checked.';
                        isValid = false;
                    }
                    break;
                }
            }
            this.valid[fieldName] = isValid;
            this.updateFormValidity();
        },

        updateFormValidity() {
            this.isFormValid = Object.values(this.valid).every(v => v);
        },

        cancel() {
            this.resetForm();
            Swal.fire('Dibatalkan', 'Formulir telah direset.', 'info');
        },

        openModal(type) {
            this.modal.type = type;
            switch (type) {
                case 'category':
                    this.modal.title = 'Add New Category';
                    this.modal.label = 'Category Name';
                    this.modal.existingItems = this.options.categories;
                    break;
                case 'poType':
                    this.modal.title = 'Add New PO Type';
                    this.modal.label = 'PO Type Name';
                    this.modal.existingItems = this.options.poTypes;
                    break;
                case 'template':
                    this.modal.title = 'Add New Template';
                    this.modal.label = 'Template Name';
                    this.modal.existingItems = this.options.templates;
                    break;
            }
            this.modal.visible = true;
        },

        closeModal() {
            this.modal.visible = false;
        },
    },

    watch: {
        'form.categoryCompanyId'() { this.validateField('categoryCompanyId'); },
        'form.customerId'() { this.validateField('customerId'); },
        'form.typePoId'() { this.validateField('typePoId'); },
        'form.templateId'() { this.validateField('templateId'); },
        'form.checklist': { handler: function () { this.validateField('checklist'); }, deep: true },
    },

    mounted() {
        this.loadDropdownData();
        this.$nextTick(() => {
            if (this.$refs.categoryCompanyIdSelect) {
                this.$refs.categoryCompanyIdSelect.focus();
            }
        });
        this.updateFormValidity();
    }
};
</script>

<style scoped>
/* Style tidak berubah */
.input-border {
    border-bottom: 2px solid #ccc;
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
}

.input-border:focus {
    border-bottom-color: #3b82f6;
    box-shadow: none;
}

.form-section {
    display: flex;
    flex-direction: column;
}

.button-add {
    @apply bg-blue-500 hover:bg-blue-600 text-white font-bold p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 flex-shrink-0;
}
</style>